import React from "react";
import { Box, Button } from "@origin-digital/ods-core";
import { useBulkDuplicateActions } from "./hooks/useBulkDuplicateActions";

const BulkDuplicateActions: React.FC = () => {
  const { handleSubmit, closeDialog, isSubmitting, buttonText } =
    useBulkDuplicateActions();

  return (
    <Box display="flex" justifyContent="flex-end">
      <Box display="flex" gap="xlarge">
        <Button onClick={() => closeDialog()} variant="text" color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          size="medium"
          spinner={isSubmitting}
        >
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
};

export default BulkDuplicateActions;
